import { Breadcrumbs, Link as MuiLink, Tooltip } from "@mui/material";
import { ConditionalWrapper } from "../../generic/components/conditional-wrapper";
import { isModifiedClick } from "../utils";

import type { TreeViewItem } from "../utils";
import type { FC } from "react";

export const FolderBreadcrumb: FC<{
  breadcrumbs: TreeViewItem[];
  onFolderSelect: (folderId: string) => void;
  /** Links each folder to this URL, so it can be opened in a new tab. */
  getFolderHref?: (folderId: string) => string;
}> = ({ breadcrumbs, onFolderSelect, getFolderHref }) => (
  <Breadcrumbs separator="/">
    {breadcrumbs.map((breadcrumb, index) => (
      <BreadcrumbLink
        key={breadcrumb.id}
        breadcrumb={breadcrumb}
        isLast={index === breadcrumbs.length - 1}
        onFolderSelect={onFolderSelect}
        href={getFolderHref?.(breadcrumb.id)}
      />
    ))}
  </Breadcrumbs>
);

const BreadcrumbLink: FC<{
  breadcrumb: TreeViewItem;
  isLast: boolean;
  onFolderSelect: (folderId: string) => void;
  href?: string;
}> = ({ breadcrumb, isLast, onFolderSelect, href }) => {
  const shouldTruncate = breadcrumb.label.length > 16;

  return (
    <ConditionalWrapper
      condition={shouldTruncate}
      // oxlint-disable-next-line react/no-unstable-nested-components -- ConditionalWrapper calls wrapper() as a plain function; it is never mounted as a component
      wrapper={(children) => (
        <Tooltip title={breadcrumb.label} enterDelay={500} placement="top">
          {children}
        </Tooltip>
      )}
    >
      <MuiLink
        {...(href && !isLast ? { href } : { component: "button" })}
        underline="none"
        onClick={
          isLast
            ? undefined
            : (event) => {
                if (href && isModifiedClick(event)) return;
                event.preventDefault();
                onFolderSelect(breadcrumb.id);
              }
        }
        sx={{
          cursor: isLast ? "default" : "pointer",
          ...(shouldTruncate && {
            maxWidth: 200,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "block",
          }),
        }}
        color={isLast ? "inherit" : "primary.main"}
      >
        {breadcrumb.label}
      </MuiLink>
    </ConditionalWrapper>
  );
};
